import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {StudentProfileViewService} from './student-profile-view.service'
import { TranslateService } from '@ngx-translate/core';

declare let $: any;
declare let momentJs: any;
declare let moment_js: any;
@Component({
  selector: 'app-student-profile-view',
  templateUrl: './student-profile-view.component.html',
  styleUrls: ['./student-profile-view.component.css'],
  providers:[StudentProfileViewService]
})
export class StudentProfileViewComponent implements OnInit {

  @Input() studentName: string;
  @Input() visible: string;
  @Input() studentId: string;
  @Input() academicId: string;
  @Output() closePopup: EventEmitter<any> = new EventEmitter();

  profileIsLoading:boolean;
  studentProfile:any = {};
  academicInfo:any = {};

  constructor(private studentProfileViewService:StudentProfileViewService, private translate: TranslateService) { }

  ngOnInit() {
    $("body").append(`<script>
      (function($){
            $.fn.getStyleObject = function(){
              let dom = this.get(0);
              var style;
              var returns = {};
              if(window.getComputedStyle){
                var camelize = function(a,b){
                  return b.toUpperCase();
                };
                style = window.getComputedStyle(dom, null);
                for(var i = 0, l = style.length; i < l; i++){
                  var prop = style[i];
                  var camel = prop.replace("/-([a-z])/g", camelize);
                  var val = style.getPropertyValue(prop);
                  returns[camel] = val;
                };
                return returns;
              };
              if(style = dom.currentStyle){
                for(var prop in style){
                  returns[prop] = style[prop];
                };
                return returns;
              };
              return this.css();
            }
          })($);
    </script>`);

    $('#print-student-profile-form').on('click', function () {
      let container = $("#student-profile-print-container");

      appendStyle(container)
      function appendStyle(container){
        let ch = container.children();
        for(let i=0; i<ch.length; i++){
          let dom = $(ch[i]);
          let childStyle = dom.getStyleObject();
          dom.css(childStyle);
          appendStyle(dom)
        }
      }

      var DocumentContainer = document.getElementById('student-profile-print-container');
      var name = "ID_CARD";
      let ch = DocumentContainer.children;
      let style = $("#student-profile-print-container").getStyleObject();

      var WindowObject = window.open(name, "Receipt","width=1500,height=1100,top=100,left=150,toolbars=no,scrollbars=yes,status=no,resizable=no");
      WindowObject.document.writeln(DocumentContainer.innerHTML);

      WindowObject.document.close();
      WindowObject.focus();
      WindowObject.open();
      (WindowObject as any).print()

      $(".hide-while-print").show();
      $("#clear-selected-students").trigger('click');
    });
    $('body').css('overflow', 'hidden');
    $('#student-profile-view-popup-top').css('overflow', 'auto');
    this.fetchStudentProfileInfo();
  }
  close(){
    $('#student-profile-view-popup-top').css('overflow', 'hidden');
    $('body').css('overflow', 'auto');
    this.visible = 'none';
    this.closePopup.emit();
  }

  fetchStudentProfileInfo(){
    this.profileIsLoading = true;
    this.studentProfileViewService.getStudentProfilePrintDetails(this.studentId,localStorage.getItem('usertoken'))
      .subscribe(
        (data: any) => {
          this.profileIsLoading = false;
          this.studentProfile = data.studentInfo;
          this.academicInfo = data.academicInfo;
        },
        error => {
          this.profileIsLoading = false;
        }
      );
  }

  formatDate(date){
    return date ? moment_js(date).format('DD-MM-YYYY') : '-';
  }
}
